@if (careService()) {
  <div
    class="w-11 h-11 min-w-11 min-h-11 lg:w-12 lg:h-12 lg:min-w-12 lg:min-h-12 border border-grey-8 relative rounded-full overflow-hidden bg-white">
    @if (logoUrl() && logoUrl() !== '') {
      <img
        [alt]="careProviderUnitName()"
        [ngSrc]="logoUrl()"
        class="object-contain w-full h-full"
        fill="true"
      >
    }
  </div>
  <div class="grow text-left flex flex-col justify-center items-start">
    <div class="text-left text-sm lg:text-base line-clamp-1">{{ careService().name }}</div>
    <div (click)="openCpruPage()"
         class="text-left font-bold text-duck-blue-2 line-clamp-1 cursor-pointer">{{ careProviderUnitName() }}
    </div>
  </div>

  @if (displayBookingBtn()) {
    <div class="hidden justify-end items-center gap-4 lg:flex">
      @for (config of careService().bookingConfigurationData; track config.id) {
        <app-booking-btn
          [bookingConfigurationData]="config"
          [caregiverContactInfo]="careProviderContactInfo()"
          [classList]="'booking-btn__narrow'"
          [isDisplayedAlone]="true"
          [mainCaregiverUnitType]="mainCaregiverUnitType()"
          [pageType]="dLPageTypeEnum.CARE_SERVICE_PAGE"
          size="lg"
        ></app-booking-btn>
      }
    </div>
  }
}

